import styled from 'styled-components'

const Invalid = (props) => {
  const { invalid } = props

  const invalidCss = invalid ? 'invalid' : ''

  return <View className={invalidCss}>{invalid || ''}</View>
}

const View = styled.div`
  color: ${(p) => p.theme.color.error};
  font-size: 14px;
  text-align: left;
  display: none;

  &.invalid {
    margin-top: 4px;
    display: block;
  }
`

export default Invalid
